<script setup lang="ts">
defineOptions({
	name: 'IconArrowThinRight',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:class="[props.class, props.classIcon]"
		viewBox="0 0 21 94"
		fill="none"
	>
		<path
			d="M1 0.5L20 47.3252L1 93.5"
			stroke="currentColor"
			stroke-linejoin="round"
		/>
	</svg>
</template>
